<template>
  <div class="fuwuNav">
    <div class="botMenulist2">
      <div class="lis-cont">
        <div class="head">助学服务</div>
        <div class="cont">
          <a href="/mobile/shenqing/0">大学申请服务</a>
          <a href="/mobile/zhusu/1">住宿预定服务</a>
          <a href="/mobile/jieji/2">机场接机服务</a>
          <a href="/mobile/visa/3">签证服务</a>
          <a href="/mobile/jiaodui/4">论文核对服务</a>
          <a href="/mobile/baoxian/5">保险申请服务</a>
          <a href="/mobile/SIM-Card/6">手机卡申请服务</a>
        </div>
        <div class="fdbtn"
             @click="$store.commit('setStatus_contFlag')">详情咨询</div>
      </div>
      <div class="lis-cont">
        <div class="head">教育中心</div>
        <div class="cont">
          <a href="/mobile/yuyan/0">中文培训中心</a>
          <a href="/mobile/kaoshi/1">考试准备中心</a>
          <a href="/mobile/jiaocai/2">官方教材</a>
        </div>
        <div class="fdbtn"
             @click="$store.commit('setStatus_contFlag')">详情咨询</div>
      </div>
      <div class="lis-cont">
        <div class="head">旅行生活</div>
        <div class="cont">
          <a href="/mobile/shenghuo/0">生活中心</a>
          <a href="/mobile/lvxing/1">旅行中心</a>
          <a href="/mobile/qiuzhi/2">求职中心</a>
          <a href="/mobile/fankui/3">反馈留言</a>
          <a href="/mobile/faq/4">常见问题</a>
        </div>
        <div class="fdbtn"
             @click="$store.commit('setStatus_contFlag')">详情咨询</div>
      </div>
    </div>
    <div class="botline">
      没有更多了
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.botMenulist2 {
  padding: 20px;
  padding-bottom: 60px;

  .lis-cont {
    position: relative;
    border-top: 10px solid #263e65;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0px 0px 8px rgba($color: #000000, $alpha: 0.2);
    margin-bottom: 30px;
    overflow: hidden;
    height: 350px;

    &:last-child {
      margin-bottom: 0;
    }
    &:nth-child(1):before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background: url(~@/assets/wufuwu1.jpg) center center no-repeat;
      background-size: 100% 100%;
      top: 0;
      left: 0;
      opacity: 0.07;
    }
    &:nth-child(2):before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background: url(~@/assets/wufuwu2.jpg) center center no-repeat;
      background-size: 100% 100%;
      top: 0;
      left: 0;
      opacity: 0.07;
    }
    &:nth-child(3):before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background: url(~@/assets/wufuwu3.jpg) center center no-repeat;
      background-size: 100% 100%;
      top: 0;
      left: 0;
      opacity: 0.07;
    }
    .head {
      font-size: 30px;
      font-weight: bold;
    }
    .cont {
      position: relative;
      z-index: 2;
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      a {
        width: 32%;
        font-size: 28px;
        line-height: 56px;
        margin-right: 2%;
        color: #545454;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
    .fdbtn {
      position: absolute;
      width: 160px;
      height: 60px;
      border-radius: 60px;
      line-height: 60px;
      text-align: center;
      color: #fff;
      background-color: #f6cb47;
      right: 20px;
      bottom: 20px;
    }
  }
}
</style>